import { useEffect } from 'react'
import { useOverlayStore } from '../store/overlay'

/**
 * Render this INSIDE a dialog's Content. Radix mounts Content only while the dialog is open, so this
 * component's mount/unmount reliably brackets the open state — it bumps the overlay count up while
 * mounted and back down on close/unmount. The mobile basket uses that count to hide itself behind
 * any open dialog (see store/overlay.ts).
 */
export function OverlayReporter() {
  useEffect(() => {
    const { push, pop } = useOverlayStore.getState()
    push()
    return pop
  }, [])
  return null
}
